import {
  MisaOutward,
  MisaOutwardDetail,
  MisaInward,
  MisaInwardDetail,
  MisaPurchase,
  MisaPurchaseDetail,
  InventoryItem,
  DeliveryOrder,
} from "../types/misa";

const FILE_MISA_TOKEN =
  "https://docs.google.com/spreadsheets/d/1MQt7mn0RLwilk2VEMW9hVKw77gHUTXYfu3ZQk62NIAw/export?format=csv&gid=0";

export async function fetchMisaToken(): Promise<string> {
  try {
    const response = await fetch(FILE_MISA_TOKEN, { redirect: "follow" });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    let csvText = await response.text();
    csvText = csvText.replace(/^\uFEFF/, "");
    const lines = csvText.split(/\r?\n/);
    let token = lines[0]?.split(",")[0] || "";
    token = token
      .replace(/^['"]|['"]$/g, "")
      .replace(/[^\x20-\x7E]/g, "")
      .trim();
    return token;
  } catch (e) {
    console.error("❌ Error loading MISA token:", e);
    return "";
  }
}

export async function fetchMisaData(
  misaToken: string,
  fromDate: string,
  toDate: string,
  branchId: string,
): Promise<MisaOutward[]> {
  const filter = [
    {
      xtype: "filter",
      property: "RefDate",
      operator: 4,
      value: `${fromDate}T00:00:00`,
      type: 2,
      group: "RefDate",
    },
    {
      xtype: "filter",
      property: "RefDate",
      operator: 3,
      value: `${toDate}T23:59:59`,
      type: 2,
      addition: 1,
      group: "RefDate",
    },
    {
      xtype: "filter",
      isFilterRow: true,
      property: "RefType",
      operator: 0,
      value: 2905,
      type: 7,
      addition: 1,
      group: "RefTypeFFR",
    },
  ];
  const encodedFilter = encodeURIComponent(JSON.stringify(filter));
  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/Outwards?_dc=${Date.now()}&page=1&start=0&limit=5000&filter=${encodedFilter}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    const result = await response.json();
    return (
      result.Data?.filter(
        (item: MisaOutward) => item.BranchName === "Kho tổng",
      ) || []
    );
  } catch (error) {
    console.error("Lỗi khi gọi MISA API:", error);
    return [];
  }
}

export async function fetchMisaDetails(
  misaToken: string,
  refId: string,
  branchId: string,
): Promise<MisaOutwardDetail[]> {
  const detailUrl = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/Outwards/OutwardDetails/${refId}?_dc=${Date.now()}&page=1&start=0&limit=500`;
  try {
    const response = await fetch(detailUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const detailResult = await response.json();
    return detailResult.data || detailResult.Data || [];
  } catch (e) {
    console.error("Lỗi khi lấy chi tiết phiếu:", e);
    return [];
  }
}

export async function fetchMisaDataNhapKho(
  misaToken: string,
  fromDate: string,
  toDate: string,
  branchId: string,
): Promise<MisaInward[]> {
  const filter = [
    {
      xtype: "filter",
      property: "RefDate",
      operator: 4,
      value: `${fromDate}T00:00:00`,
      type: 2,
      group: "RefDate",
    },
    {
      xtype: "filter",
      property: "RefDate",
      operator: 3,
      value: `${toDate}T23:59:59`,
      type: 2,
      addition: 1,
      group: "RefDate",
    },
    {
      xtype: "filter",
      isFilterRow: true,
      property: "RefType",
      operator: 0,
      value: 2094,
      type: 7,
      addition: 1,
      group: "RefTypeFFR",
    },
  ];
  const encodedFilter = encodeURIComponent(JSON.stringify(filter));
  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/INInwards?_dc=${Date.now()}&page=1&start=0&limit=5000&filter=${encodedFilter}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    const result = await response.json();
    return result.Data || [];
  } catch (error) {
    console.error("Lỗi khi gọi MISA API nhập kho:", error);
    return [];
  }
}

export async function fetchMisaInwardDetails(
  misaToken: string,
  refId: string,
  branchId: string,
): Promise<MisaInwardDetail[]> {
  const detailUrl = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/INInwards/INInwardDetail/${refId}?_dc=${Date.now()}&page=1&start=0&limit=500`;
  try {
    const response = await fetch(detailUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const detailResult = await response.json();
    return detailResult.data || detailResult.Data || [];
  } catch (e) {
    console.error("Lỗi khi lấy chi tiết phiếu nhập kho:", e);
    return [];
  }
}

export async function fetchMisaDataNhapHang(
  misaToken: string,
  fromDate: string,
  toDate: string,
  branchId: string,
): Promise<MisaPurchase[]> {
  const filter = [
    {
      xtype: "filter",
      property: "RefDate",
      operator: 4,
      value: `${fromDate}T00:00:00`,
      type: 2,
      group: "RefDate",
    },
    {
      xtype: "filter",
      property: "RefDate",
      operator: 3,
      value: `${toDate}T23:59:59`,
      type: 2,
      addition: 1,
      group: "RefDate",
    },
    {
      xtype: "filter",
      isFilterRow: true,
      property: "RefType",
      operator: 0,
      value: 301,
      type: 7,
      addition: 1,
      group: "RefTypeFFR",
    },
  ];
  const encodedFilter = encodeURIComponent(JSON.stringify(filter));
  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/INInwards?_dc=${Date.now()}&page=1&start=0&limit=5000&filter=${encodedFilter}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    const result = await response.json();
    return result.Data || [];
  } catch (error) {
    console.error("Lỗi khi gọi MISA API nhập hàng:", error);
    return [];
  }
}

export async function fetchMisaPurchaseDetails(
  misaToken: string,
  refId: string,
  branchId: string,
): Promise<MisaPurchaseDetail[]> {
  const detailUrl = `https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/invoices/detail/${refId}?_dc=${Date.now()}&page=1&start=0&limit=500`;
  try {
    const response = await fetch(detailUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": branchId,
      },
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const detailResult = await response.json();
    return detailResult.data || detailResult.Data || [];
  } catch (e) {
    console.error("Lỗi khi lấy chi tiết phiếu nhập hàng:", e);
    return [];
  }
}

export async function fetchDeliveryOrders(
  misaToken: string,
  fromDate: string,
  toDate: string,
  refNoFilter?: string,
): Promise<DeliveryOrder[]> {
  const filter: any[] = [];
  if (refNoFilter) {
    filter.push({
      xtype: "filter",
      isFilterRow: true,
      property: "RefNo",
      operator: 8,
      value: refNoFilter,
      type: 1,
    });
  }

  const params = new URLSearchParams({
    _dc: String(Date.now()),
    listTagID: "",
    filterDateType: "2",
    fromDate: `${fromDate}T00:00:00`,
    toDate: `${toDate}T23:59:59`,
    page: "1",
    start: "0",
    limit: "5000",
    filter: JSON.stringify(filter),
  });

  const url = `https://nhathuocpharceco.mshopkeeper.vn/backendg1/api/DeliveryLedger?${params.toString()}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        companycode: "nhathuocpharceco",
      },
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const result = await response.json();
    return result.Data || result.data || [];
  } catch (error) {
    console.error("Lỗi khi gọi API DeliveryLedger:", error);
    return [];
  }
}

type ApiResponse = {
  total?: number;
  data?: InventoryItem[];
};

const INVENTORY_BASE_URL =
  "https://nhathuocpharceco.mshopkeeper.vn/backendg2/api/InventoryItem";

export async function fetchInventory(
  misaToken: string,
  params: Record<string, any>,
): Promise<ApiResponse> {
  const queryParams = {
    _dc: Date.now(),
    page: params.page || 1,
    limit: params.limit || 100,
    inventoryItemCategoryID: "00000000-0000-0000-0000-000000000000",
    branchID: "66847e41-5b66-4529-b955-e63c7e8b50b0",
    isOutStock: 0,
    start: 0,
    sort: '[{"property":"InventoryItemName","direction":"ASC"}]',
    filter:
      '[{"xtype":"filter","isFilterRow":true,"property":"Inactive","operator":0,"value":0,"type":7}]',
  };

  const url = `${INVENTORY_BASE_URL}?_dc=${queryParams._dc}&page=${
    queryParams.page
  }&start=${queryParams.start}&limit=${
    queryParams.limit
  }&inventoryItemCategoryID=${encodeURIComponent(
    queryParams.inventoryItemCategoryID,
  )}&branchID=${encodeURIComponent(
    queryParams.branchID,
  )}&isOutStock=${encodeURIComponent(
    queryParams.isOutStock,
  )}&sort=${encodeURIComponent(queryParams.sort)}&filter=${queryParams.filter}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        authorization: `Bearer ${misaToken}`,
        "x-misa-branchid": "66847e41-5b66-4529-b955-e63c7e8b50b0",
      },
    });
    const json = await response.json();

    const total = json?.total || json?.Total || 0;
    const data = json?.data || json?.Data || [];
    return { total, data };
  } catch (e) {
    console.error("Lỗi khi lấy dữ liệu hàng tồn kho:", e);
    return {};
  }
}
